// Refine +1 a +30 (documento de design): a falha nunca destrói o item; ao falhar há 50% de chance de cair um nível; sem pity.
// Pedras de proteção (10 fragmentos = 1 pedra) impedem a queda numa falha e multiplicam o custo da tentativa (x3 até o +25,
// x5 do +26 ao +30); o custo é sempre pago e a pedra só é gasta se a tentativa falhar.
// Custos e chances endurecidos a pedido do Arthur (13/10/2026): em média, chegar ao +20 custa ~48 milhões, ao +25 ~380 milhões
// e ao +30 ~4,4 bilhões de gold e ~135 pedras (usando pedras do +16 em diante); sem pedras, o +30 é praticamente impossível.
export const REFINE_MAX = 30;
export const REFINE_PROTECT_MAX = 30;
/** quanto a pedra multiplica o custo da tentativa */
export const protectMult = (to: number) => (to > 25 ? 5 : 3);
export const FRAGMENTS_PER_STONE = 10;
export const REFINE_DROP_CHANCE = 0.5;

/** chance de sucesso (%) para chegar ao nível `to` (1..30) */
export function refineChance(to: number): number {
  if (to <= 5) return 100 - (to - 1) * 5;          // +1 100% … +5 80%
  if (to <= 10) return 70 - (to - 6) * 5;          // +6 70% … +10 50%
  if (to <= 20) return 45 - (to - 11) * 2.5;       // +11 45% … +20 22,5%
  if (to <= 25) return [16, 14, 12, 10, 9][to - 21]!;   // +21 16% … +25 9%
  return [8, 7, 6, 5, 4][to - 26]!;                     // +26 8% … +30 4%
}
/** custo em gold de uma tentativa para chegar ao nível `to` */
export const refineCost = (to: number) => Math.round(10_000 * Math.pow(1.28, to - 1) / 100) * 100;   // +1 10 mil · +10 92 mil · +20 1,1 mi · +30 12,9 mi

/** só equipamentos de combate */
export const REFINABLE_SLOTS = ['weapon', 'shield', 'head', 'armor', 'legs', 'feet', 'ammo'];
